<template>
  <b-link
    class="font-size-sm"
    :to="{ name: path, params: { id: reference.id } }"
  >
    {{ displayLabel }}
  </b-link>
</template>

<script>

export default {
  name: 'TimelineItemReference',
  props: {
    referenceType: {
      type: String,
      required: true,
    },
    reference: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      referenceOptions: {
        'WorkOrder': {
          name: 'Work Order',
          path: 'work-order',
          labelKey: 'number',
        },
        'Location': {
          name: 'Location',
          path: 'location',
          labelKey: 'store_number',
        },
        'ComplianceDocument': {
          name: 'Compliance Document',
          path: 'compliance-document',
          labelKey: 'number',
        },
      },
    };
  },
  computed: {
    name() {
      return this.referenceOptions[this.referenceType]?.name;
    },
    label() {
      return this.reference[this.referenceOptions[this.referenceType]?.labelKey];
    },
    displayLabel() {
      return `${this.name} ${this.label}`;
    },
    path() {
      return this.referenceOptions[this.referenceType]?.path;
    },
  },
};
</script>
